<template>
  <div>
    <div class="flex justify-between flex-wrap">
      <h3 class="title mb-6">Nieuwe entiteit toevoegen</h3>
    </div>

    <EntityForm :initialValues="initialValues" :onCancel="handleCancel" :onSubmit="handleSubmit" />
  </div>
</template>

<script>
import EntityForm from '@/components/EntityForm';
import { HorizontalWrapper } from '@/components/FormFields';
import { entities } from '@/config/endpoints';
import { SHOW_TOAST } from '@/constants';

export default {
  name: 'NewEntity',

  components: { EntityForm, HorizontalWrapper },

  data() {
    return {
      initialValues: {
        name: '',
        active: true,
        exceptionallyClosed: '',
      },
      showModal: false,
    };
  },

  methods: {
    handleCancel() {
      this.$router.push({ name: 'entities' });
    },

    handleError({ message }) {
      this.showModal = false;

      this.$store.dispatch(SHOW_TOAST, {
        message,
        type: 'is-danger',
      });
    },

    handleSubmit(dirtyData) {
      this.$api(entities, {
        body: dirtyData,
        method: 'put',
      })
        .then(() => this.handleSuccess('Entiteit toegevoegd'))
        .catch(this.handleError);
    },

    handleSuccess(message) {
      this.$store.dispatch(SHOW_TOAST, {
        message,
        type: 'is-success',
      });

      this.$router.push({ name: 'entities' });
    },
  },
};
</script>
